import React, {useState} from 'react';

import styled from 'styled-components';

import {ClickToEditButton} from 'app/components/general/ClickToEditButton';
import {
  CompanyLogo,
  StyledCompanyLogoDiv,
} from 'app/general/structures/SPFrame/SPHeader/CompanyLogo';
import {FineImageUploaderArea} from 'app/general/widgets/FineImageUploaderArea';
import {gt} from 'app/utils/i18n';

type LogoProps = {
  onUpdate: (logo: string) => unknown;
};

export const EditableLogo = ({onUpdate}: LogoProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [temporaryLogo, setTemporaryLogo] = useState<string | undefined>(
    undefined
  );

  const onAddImage = (image) => {
    setTemporaryLogo(image.image_ref);
    setIsEditing(false);
    onUpdate(image.image_ref);
  };

  return (
    <>
      {isEditing ? (
        <StyledCompanyLogoDiv
          className={
            'text-white d-flex justify-content-center align-items-center p-1'
          }
        >
          <StyledDropZoneDiv>
            <div className="upload-area-container">
              <FineImageUploaderArea onAddImage={onAddImage} />
            </div>
          </StyledDropZoneDiv>
        </StyledCompanyLogoDiv>
      ) : (
        <CompanyLogo forceLogoURL={temporaryLogo} link={null}>
          <ClickToEditButton
            onClick={() => {
              setIsEditing(true);
            }}
            className={'text-white mr-2'}
            tooltip={gt('Upload your company logo')}
          />
        </CompanyLogo>
      )}
    </>
  );
};

export const StyledDropZoneDiv = styled.div`
  .upload-area-container {
    position: relative;
  }

  .file-upload {
    border: 4px dashed #ccc;
    background: #f2fdf3;

    .drop {
      visibility: hidden;
      opacity: 0;
      transition: all 250ms;
      background: #defbff;
      z-index: 1;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      font-size: 1.5rem;
      i {
        font-size: 2.5rem;
      }
    }

    &.active .drop {
      opacity: 1;
      visibility: visible;
    }
  }

  &.idle .file-upload {
    border-width: 4px;
    height: 190px;
    padding: 30px 0;
    opacity: 1;
  }

  .uploads-list,
  .file-upload,
  .uploading-content,
  .processing-content,
  .error-content,
  .success-content {
    position: relative;
    height: 0;
    border-width: 0;
    overflow: hidden;
    transition: all 0.25s;
    padding: 0;
    opacity: 0;
  }

  &.processing .processing-content,
  &.success .success-content,
  &.error .error-content {
    height: 100px;
    opacity: 1;
  }
`;
